import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import * as fromStrideReviewReducer from './stride-review-reducer';
import { StrideReasonsDetailItem } from '@sleipai/sleip-models';

export const strideReasonsDetailItemAdapter: EntityAdapter<StrideReasonsDetailItem> =
  createEntityAdapter<StrideReasonsDetailItem>({
    selectId: selectStrideReasonsDetailItemId,
  });

export function selectStrideReasonsDetailItemId(
  strideReasonsDetailItem: StrideReasonsDetailItem
) {
  return strideReasonsDetailItem.recordingId ?? '';
}

export const selectStrideReasonsDetailItemState = (
  state: fromStrideReviewReducer.State
) => state.reasons;

export const { selectAll: selectAllStrideReasonsDetailItems } =
  strideReasonsDetailItemAdapter.getSelectors();

export interface StrideReasonsDetailItemState
  extends EntityState<StrideReasonsDetailItem> {}
